import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { BillingUiModule } from '@vendasta/billing-ui';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { EditionSelectorComponent } from './edition-selector/edition-selector.component';
import { FindItemEditionPipe } from './edition-selector/find-item-edition.pipe';
import { FrequencySelectorComponent } from './frequency-selector/frequency-selector.component';
import { ItemLabelComponent } from './item-label/item-label.component';
import { ItemListComponent } from './item-list/item-list.component';
import { FormatBillingPeriodPipe } from './billing-terms/billing-period.pipe';
import { CentsToDollarsPipe } from './pipes/cents-to-dollars.pipe';
import { PriceValidatorPipe } from './pipes/price-validator.pipe';
import { ToStringPipe } from './pipes/to-string.pipe';
import { PriceSummaryDisplayComponent } from './price-summary-display/price-summary-display.component';
import { MatDialogModule } from '@angular/material/dialog';
import { FormatWholesaleMinimumHintPipe } from './pipes/format-wholesale-minimum-hint.pipe';
import { HasSetupFeePipe } from './pipes/has-setup-fee.pipe';
import { IsSetupFeeRemovablePipe } from './pipes/is-setup-fee-removable.pipe';
import { FormatBillingTermPipe } from './billing-terms/format-billing-term.pipe';

export const ITEM_COMMON_MODULE_IMPORTS = [
  CommonModule,
  MatButtonModule,
  MatChipsModule,
  MatIconModule,
  MatListModule,
  BillingUiModule,
  GalaxyAvatarModule,
  GalaxyFormFieldModule,
  MatSelectModule,
  GalaxyBadgeModule,
  MatDialogModule,
];

export const ITEM_COMMON_MODULE_PROVIDERS = [DatePipe, FormatBillingPeriodPipe];

export const ITEM_COMMON_MODULE_EXPORTS = [
  ItemLabelComponent,
  ItemListComponent,
  CentsToDollarsPipe,
  PriceValidatorPipe,
  ToStringPipe,
  PriceSummaryDisplayComponent,
  FormatBillingPeriodPipe,
  EditionSelectorComponent,
  FrequencySelectorComponent,
  FindItemEditionPipe,
  FormatWholesaleMinimumHintPipe,
  HasSetupFeePipe,
  IsSetupFeeRemovablePipe,
  FormatBillingTermPipe,
];

export const ITEM_COMMON_MODULE_DECLARATIONS = [
  ItemLabelComponent,
  ItemListComponent,
  CentsToDollarsPipe,
  PriceValidatorPipe,
  ToStringPipe,
  PriceSummaryDisplayComponent,
  FormatBillingPeriodPipe,
  EditionSelectorComponent,
  FrequencySelectorComponent,
  FindItemEditionPipe,
  FormatWholesaleMinimumHintPipe,
  HasSetupFeePipe,
  IsSetupFeeRemovablePipe,
  FormatBillingTermPipe,
];

@NgModule({
  imports: ITEM_COMMON_MODULE_IMPORTS,
  exports: ITEM_COMMON_MODULE_EXPORTS,
  declarations: ITEM_COMMON_MODULE_DECLARATIONS,
  providers: ITEM_COMMON_MODULE_PROVIDERS,
})
export class ItemCommonModule {}
